export default class InputSelectOpen {
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...InputSelectOpen.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$selectOpen = this.DOM.$el.querySelector(this.options.selectorSelect)
        if (this.DOM.$selectOpen) {
            this.DOM.$selectOpen.addEventListener('change', (e) => {
                let input = e.target.parentNode.parentNode.querySelector(this.options.selectorInput);
                // show the text field if the selected option is the last one
                if (e.target.value == e.target.options[e.target.options.length - 1].value) {
                    input.classList.remove('u-hide');
                    if (e.target.hasAttribute('required')) {
                        input.setAttribute('required', 'required');
                    }
                    if (input.hasAttribute('disabled')) {
                        input.removeAttribute('disabled')
                    }
                } else {
                    input.classList.add('u-hide')
                    input.removeAttribute('required')
                    input.setAttribute('disabled', 'disabled')
                }
            });
        }
    }
}

InputSelectOpen.prototype.defaults = {
    selectorSelect: '.c-inputSelect__select',
    selectorInput: '.c-inputText',
}